import {
	message
} from "antd";
import ForgotPasswordConstants from "../constants/ForgotPasswordConstants";

export default function (
	state = {
		loading: false
	},
	action
) {
	switch (action.type) {
		case ForgotPasswordConstants.FORGOT_REQUEST:
			return { ...state,
				loading: true
			};
		case ForgotPasswordConstants.FORGOT_SUCCESS:
			message.success(action.payload);
			return { ...state,
				loading: false
			};
		case ForgotPasswordConstants.FORGOT_FAILURE:
			message.error(action.payload);
			return { ...state,
				loading: false
			};
		default:
			return state;
	}
}
